import { createApiHook } from '../hooks';
import { campaignsApiFactory } from './campaignsApiFactory';

export const useCampaignsApi = createApiHook(campaignsApiFactory);
